// Map guarantees correct ordering for frequencyOptions
const frequencyMap: Map<string, string> = new Map([
  ['1OA', 'One time'],
  ['1WA', 'Every week'],
  ['2WA', 'Every other week'],
  ['1MA', 'Every month'],
  ['2MA', 'Every 2 months'],
  ['3MA', 'Every 3 months'],
  ['4MA', 'Every 4 months'],
  ['1YA', 'Every year'],
])

export const BUCKET_FREQUENCY_MAP: Record<string, string> =
  Object.fromEntries(frequencyMap)

export const frequencyOptions = Array.from(frequencyMap).map(
  ([value, label]) => ({ value, label }),
)
